<template>
  <div class="personal-loan-interest-rate">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('string.editPurchasingInterestRate') }}
        </h3>
      </div>
      <div class="box-body">
        <purchasing-interest-rate-form />
      </div>
    </div>
  </div>
</template>

<script>
import PurchasingInterestRateForm from './Form'
export default {
  name: 'Edit',
  components: { PurchasingInterestRateForm },
  metaInfo () {
    return {
      title: this.$t('string.editPurchasingInterestRate'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  }
}
</script>

<style scoped>

</style>
